export default {
  title: "Rapport betaalde facturen"
}
